/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Typography } from '@mui/material';
import React from 'react';

import { useHistory } from 'react-router-dom';
import MenuItems from '../../common/layout/menu/MenuItems';
import FormModal from '../../common/modals/FormModal';

interface MissionPlanNotLoadedModalProps {
  open: boolean;
  onClose: () => void;
}

function MissionPlanNotLoadedModal({ open, onClose }: MissionPlanNotLoadedModalProps) {
  const history = useHistory();

  const handleRedirect = () => {
    history.push(`/${MenuItems.plans}/`);
  };

  return (
    <FormModal
      open={open}
      onClose={onClose}
      onSubmit={handleRedirect}
      submitText="View mission plans"
      hideCloseButton
      title="Unable to load mission"
    >
      <Typography sx={{ padding: '0 24px 24px 24px' }}>
        Go back to the mission plans page to select a mission plan.
      </Typography>
    </FormModal>
  );
}

export default MissionPlanNotLoadedModal;
